import React from "react";
import "./RevertAllModal.css";

interface Props {
  changedCount: number;
  onCancel: () => void;
  onConfirm: () => void;
  reverting: boolean;
}

const RevertAllModal: React.FC<Props> = ({
  changedCount,
  onCancel,
  onConfirm,
  reverting,
}) => {
  return (
    <div className="revert-all-overlay" onClick={reverting ? undefined : onCancel}>
      <div className="revert-all-modal" onClick={(e) => e.stopPropagation()}>
        <div className="revert-all-title">Revert All Changes</div>
        <p className="revert-all-message">
          You are about to revert all changes to{" "}
          <strong>{changedCount}</strong>{" "}
          {changedCount === 1 ? "activity" : "activities"}. This will restore
          them to their original values.
        </p>
        <p className="revert-all-warning">This action cannot be undone.</p>
        <div className="revert-all-actions">
          <button className="revert-all-cancel" onClick={onCancel} disabled={reverting}>
            Cancel
          </button>
          <button
            className="revert-all-confirm"
            onClick={onConfirm}
            disabled={reverting}
          >
            {reverting ? "Reverting..." : `Revert All (${changedCount})`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RevertAllModal;
